import { supabase } from "../supabase";

const channelStore = new Map();

const createFallbackPresenceKey = () => `viewer_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

const createEntry = (bandId, presenceKey) => {
  const key = presenceKey || createFallbackPresenceKey();
  const channel = supabase.channel(`band_leader:${bandId}`, {
    config: {
      broadcast: { ack: true },
      presence: { key },
    },
  });

  const broadcastListeners = new Map();
  const presenceListeners = new Map();
  const statusListeners = new Set();

  const entry = {
    bandId,
    channel,
    presenceKey: key,
    refCount: 0,
    lastStatus: null,
    addBroadcastListener(event, handler) {
      if (!broadcastListeners.has(event)) {
        const listeners = new Set();
        broadcastListeners.set(event, listeners);
        channel.on("broadcast", { event }, (args) => {
          listeners.forEach((listener) => listener(args));
        });
      }
      const listeners = broadcastListeners.get(event);
      listeners.add(handler);
      return () => {
        listeners.delete(handler);
      };
    },
    addPresenceListener(event, handler) {
      if (!presenceListeners.has(event)) {
        const listeners = new Set();
        presenceListeners.set(event, listeners);
        channel.on("presence", { event }, (args) => {
          listeners.forEach((listener) => listener(args));
        });
      }
      const listeners = presenceListeners.get(event);
      listeners.add(handler);
      return () => {
        listeners.delete(handler);
      };
    },
    addStatusListener(handler) {
      statusListeners.add(handler);
      if (entry.lastStatus) {
        handler(entry.lastStatus);
      }
      return () => {
        statusListeners.delete(handler);
      };
    },
    send(event, payload) {
      channel.send({
        type: "broadcast",
        event,
        payload,
      });
    },
    presenceState() {
      return channel.presenceState();
    },
    track(payload) {
      channel.track?.(payload);
    },
  };

  channel.subscribe((status) => {
    entry.lastStatus = status;
    statusListeners.forEach((listener) => listener(status));
  });

  return entry;
};

export const acquireBandLeaderChannel = ({ bandId, presenceKey }) => {
  if (!bandId) return null;
  let entry = channelStore.get(bandId);
  if (!entry) {
    entry = createEntry(bandId, presenceKey);
    channelStore.set(bandId, entry);
  }
  entry.refCount += 1;
  return entry;
};

export const releaseBandLeaderChannel = (bandId) => {
  if (!bandId) return;
  const entry = channelStore.get(bandId);
  if (!entry) return;
  entry.refCount -= 1;
  if (entry.refCount <= 0) {
    supabase.removeChannel(entry.channel);
    channelStore.delete(bandId);
  }
};
